<template>
  <div>
    <div class="page-actions">
      <span>币种： </span>
      <el-select v-model="coinType" placeholder="请选择币种">
        <el-option value="">全部</el-option>
        <el-option
          v-for="item in coinList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="days"
        type="date"
        placeholder="选择日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="createTime" label="时间">
        <template slot-scope="scope">
          {{ scope.row.time | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="amount" label="数量"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'chargeList',
  data() {
    return {
      days: '',
      coinType: ''
    };
  },

  computed: {
    ...mapState('chargeList', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList'
    ])
  },
  methods: {
    ...mapActions('chargeList', ['list']),
    ...mapMutations('chargeList', ['setpage']),
    search(data) {
      this.list({
        coinType: this.coinType,
        days: this.days,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    }
  },
  components: {
    Pagination
  }
};
</script>

<style lang="less" scoped></style>
